//captcha init
var captchaWidgetId, 
  modalDemoReqMsg;  

var webinarModalForm = (function () {
  var csrf_token;

  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var openWebinarModalForm = document.querySelectorAll(
      ".open-webinar-modal-form"
    );

    for (var i = 0; i < openWebinarModalForm.length; i++) {
      openWebinarModalForm[i].addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          loadRecaptchaForDemoModal(); // load recaptcha for webinar demo form

          captchaWidgetId = undefined;

          var modalContainer = document.querySelector(".webinar-modal-form");
          if (modalContainer) {
            webinarModal = new tingle.modal({
              focusAfterClosed: this,
              cssClass: ["webinar-pop-up-form", "style-2"],
              onOpen: function () {
                loadZoomInfoScriptForForm(); // load zoominfo js
              },
              onClose: function () {
                //Close Event
                webinarModal.destroy();
              },
            });
            webinarModal.setContent(modalContainer.innerHTML);
            webinarModal.open();

            //form initialise
            webinarModalFormInit();
          }
        },
        false
      );
    }
  };

  function webinarModalFormInit() {
    // demo requested radio btn option in webinar form
    var modalDemoReqOpt = document.querySelector('.tingle-modal #modal-demo-request-option'),
      modalDemoReqOptHeight = modalDemoReqOpt ? modalDemoReqOpt.offsetHeight : 0;

    if (modalDemoReqOptHeight) {
      modalDemoReqMsg = 'Not Selected';  // default msg
      var modalRadioElemField = modalDemoReqOpt.querySelectorAll('.input-radiobox');
      for (var j = 0; j < modalRadioElemField.length; j++) {
        modalRadioElemField[j].addEventListener('change', function() {
          modalDemoReqMsg = this.value;
        });
      }
    }

    // Set the page URL hidden field with page url value
    var getCurrentPageURL = window.location.href,
      getPageURLInput = document.getElementById("webinar-modal-page-url");

    if (getPageURLInput) {
      getPageURLInput.value = getCurrentPageURL.trim();
    }

    // render recaptcha for modal form
    if (!captchaWidgetId) {
      captchaWidgetId = renderWebinarCaptchaField();
    }

    var emailField = document.getElementById("webinar-modal-email");
    if (emailField) {
      //focus
      emailField.addEventListener("focus", function () {
        var that = this,
          emailError = document.getElementById("webinar-email-error");

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        that.classList.remove("error-border");

        if (!csrf_token) {
          // XHR request for user token
          bsLib.ajax(
            "GET",
            bsLib.railsHost() + "/user/token.json",
            {},
            false,
            {},
            // Success message for user token.
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);
              csrf_token = dataRequest.csrf_token;
            },
            // Custom Error message for user token.
            function () {
              return "user token not working";
            }
          );
        }
      });
      //blur
      emailField.addEventListener("blur", function (event) {
        var validEmail = true,
          that = this,
          submitBtn = document.getElementById("webinar-modal-submit"),
          emailError = document.getElementById("webinar-email-error"),
          pageSlug = window.location.pathname,
          pageSlug = pageSlug.replace(/^\/|\/$/g, "");

        //false valid dataset
        that.dataset.notvalid = "0";

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        // render recaptcha for modal form
        if (!captchaWidgetId) {
          captchaWidgetId = renderWebinarCaptchaField();
        }

        if (
          that.value.trim().length == 0 ||
          !bsLib.validEmail(that.value.trim())
        ) {
          validEmail = false;

          that.classList.add("error-border");
          that.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="webinar-email-error">' +
              (that.value.trim().length == 0
                ? Messages.salesAndSupportPage.noemail
                : Messages.salesAndSupportPage.invalidEmail) +
              "</span>"
          );
        } else {
          that.classList.remove("error-border");
        }

        if (validEmail) {
          //Disable submit button
          if (submitBtn) {
            submitBtn.setAttribute("disabled", "disabled");
            submitBtn.value = Messages.salesAndSupportPage.validateText;
          }

          var bstackAPI,
            emailErrorMsg;

          if (pageSlug === 'events/breakpoint') {
            bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim()) + "&event=breakpoint";
            emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
          } else {
            bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim()) + "&source=paid_ads";
            emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail;
          }

          bsLib.ajax(
            "GET",
            bstackAPI,
            {},
            true,
            {
              "X-CSRF-Token": csrf_token,
              "content-type":
                "application/x-www-form-urlencoded; charset=utf-8", // Setting content type.
            },
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);

              //remove disable
              if (submitBtn) {
                submitBtn.removeAttribute("disabled");
                submitBtn.value = submitBtn.dataset.btntext;
              }

              if (dataRequest.valid === false) {
                that.dataset.notvalid = "1";

                that.classList.add("error-border");
                if (
                  that.parentNode.getElementsByClassName("error-message")
                    .length === 0
                ) {
                  that.insertAdjacentHTML(
                    "afterend",
                    '<span class="error-message" id="webinar-email-error">' +
                      emailErrorMsg +
                      "</span>"
                  );
                }
              }
            },
            function () {}
          );
        }
      });
    }
  }

  function loadRecaptchaForDemoModal() {
    var captchaField = document.getElementById("recaptcha-js");
    if (!captchaField && typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
  }

  function loadZoomInfoScriptForForm() {
    var zoomInfoJS = document.getElementById('zoominfo-script');
      
    if (!zoomInfoJS && enableZoomInfoJs) {
      window[(function(_XuP,_zF){var _iL="";for(var _o0=0;_o0<_XuP.length;_o0++){_45!=_o0;_zF>8;var _45=_XuP[_o0].charCodeAt();_45-=_zF;_45+=61;_45%=94;_45+=33;_iL==_iL;_iL+=String.fromCharCode(_45)}return _iL})(atob('e2pxNTItKCY3bCg8'), 33)] = '5d4c63d7351669843156';
      var zi = document.createElement('script');
      (zi.type = 'text/javascript'),
      (zi.async = true),
      (zi.id = 'zoominfo-script'),
      (zi.src = (function(_Mvc,_UU){var _3s="";for(var _ED=0;_ED<_Mvc.length;_ED++){var _TW=_Mvc[_ED].charCodeAt();_TW-=_UU;_UU>3;_3s==_3s;_TW+=61;_TW!=_ED;_TW%=94;_TW+=33;_3s+=String.fromCharCode(_TW)}return _3s})(atob('cn5+en1EOTl0fTgmczd9bXxzen59OG15dzkmczd+a3E4dH0='), 10)),
      document.readyState === 'complete' ? document.body.appendChild(zi) :
      window.addEventListener('load', function(){
        document.body.appendChild(zi)
      });
    }
  }

  init();
})();

function renderWebinarCaptchaField() {
  //remove captcha
  var captchaWidget,
    modalTingle = document.getElementById("tingle-modal-box"),
    captchaFieldShow = document.querySelector(".g-recaptcha.show"),
    captchaField = document.getElementById("webinarformcaptcha");
  //remove all grecaptcha from dom
  if (captchaFieldShow && typeof grecaptcha !== "undefined") {
    if (captchaFieldShow.innerHTML !== "") {
      captchaFieldShow.innerHTML = "";
    }
  }

  //recaptcha render from JS
  if (
    typeof grecaptcha !== "undefined" &&
    typeof grecaptcha.render !== "undefined" &&
    captchaField.childNodes.length === 0
  ) {
    captchaWidget = grecaptcha.render(captchaField, {
      sitekey: captchaField.dataset.sitekey,
      theme: "light",
      badge: "bottomleft",
      size: "invisible",
      callback: function () {
        return webinarModalFormValidation(captchaWidget);
      },
    });

    modalTingle.dataset.gWidgetId = captchaWidget;
  } else if (typeof grecaptcha !== "undefined" &&
    captchaField.childNodes.length >= 0) {
    captchaWidget = modalTingle.dataset.gWidgetId;
  }
  return captchaWidget;
}

//form those have captcha
function webinarFormValidationCaptcha(captchaWidgetId) {
  var ContactForm = {};
  ContactForm.fnameField = document.getElementById("webinar-modal-fname");
  ContactForm.emailField = document.getElementById("webinar-modal-email");
  ContactForm.lnameField = document.getElementById("webinar-modal-lname");

  // Error fields creation
  ContactForm.fnameError = document.getElementById("webinar-fname-error");
  ContactForm.webinarModalEmailError = document.getElementById(
    "webinar-email-error"
  );
  ContactForm.lnameError = document.getElementById("webinar-lname-error");

  // render recaptcha for modal form
  if (!captchaWidgetId) {
    captchaWidgetId = renderWebinarCaptchaField();
  }
    
  function form_validation(
    fieldName,
    fieldError,
    idError,
    errorMessage,
    isEmail,
    isSelectBox,
    emailErrorMessage
  ) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              emailErrorMessage +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    "webinar-fname-error",
    "please share your first name",
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.webinarModalEmailError,
    "webinar-email-error",
    "please share your email address",
    true,
    false,
    "please share your vaild email address"
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    "webinar-lname-error",
    "please share your last name",
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === "" ||
    contactform_field(ContactForm.emailField) === "" ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.lnameField) === ""
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML(
      "afterend",
      '<span class="error-message" id="webinar-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        "</span>"
    );

    return false;
  } else {
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.execute(captchaWidgetId);
    }
  }
  return false;
}

function webinarModalFormValidation(captchaWidgetId) {
  var ContactForm = {},
    websiteHost = window.location.protocol + "//" + window.location.hostname;
  ContactForm.fnameField = document.getElementById("webinar-modal-fname");
  ContactForm.emailField = document.getElementById("webinar-modal-email");
  ContactForm.lnameField = document.getElementById("webinar-modal-lname");

  // Error fields creation
  ContactForm.fnameError = document.getElementById("webinar-fname-error");
  ContactForm.webinarModalEmailError = document.getElementById(
    "webinar-email-error"
  );
  ContactForm.lnameError = document.getElementById("webinar-lname-error");

  function form_validation(
    fieldName,
    fieldError,
    idError,
    errorMessage,
    isEmail,
    isSelectBox,
    emailErrorMessage
  ) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              emailErrorMessage +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    "webinar-fname-error",
    "please share your first name",
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.webinarModalEmailError,
    "webinar-email-error",
    "please share your email address",
    true,
    false,
    "please share your vaild email address"
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    "webinar-lname-error",
    "please share your last name",
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === "" ||
    contactform_field(ContactForm.emailField) === "" ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.lnameField) === ""
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML(
      "afterend",
      '<span class="error-message" id="webinar-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        "</span>"
    );

    return false;
  } else {
    var submitBtn = document.getElementById("webinar-modal-submit"),
      webinarFormBlock = document.getElementById("webinar-modal-container"),
      formPageUrl = document.getElementById("webinar-modal-page-url"),
      formListId = document.getElementById("webinar-modal-list-id"),
      formTag = document.getElementById("webinar-modal-tag"),
      formPostId = document.getElementById("webinar-modal-post-id"),
      formId = document.getElementById("webinar-modal-id"),
      formPageView = document.getElementById("webinar-modal-page-view"),
      formGAGoal = document.getElementById("webinar-modal-ga-goal"),
      formLinkedinPixel = document.getElementById(
        "webinar-modal-linkedin-pixel"
      ),
      formRedirect = document.getElementById("webinar-modal-redirect-url"),
      contactformcaptcha = document.getElementById("webinarformcaptcha"),
      userStateForEvent = document.getElementById("webinar-modal-user_state_for_event"),
      formCompany = document.querySelector('[name="company"]'),
      formTitle = document.querySelector('[name="title"]'),
      formPhoneNumber = document.querySelector('[name="phone_number"]'),
      formMobileNumber = document.querySelector('[name="mobile_number"]'),
      formCompanyCountry = document.querySelector('[name="company_country"]'),
      formCompanyWebsite = document.querySelector('[name="company_website"]'),
      formManagementLevel = document.querySelector('[name="management_level"]'),
      formCompanySize = document.querySelector('[name="company_size"]'),
      formJobFunction = document.querySelector('[name="job_function"]'),
      formJobDepartment = document.querySelector('[name="job_department"]'),
      formCompanyIndustry = document.querySelector('[name="company_industry"]'),
      formSecondaryEmailAddress = document.querySelector('[name="secondary_email_address"]'),
      formLinkedInLead = document.querySelector('[name="person_linkedin_url"]'),
      formEmailValidityCheck = document.querySelector('[name="neverbounce_email_status"]'),
      formEstimatedRevenue = document.querySelector('[name="company_revenue"]'),
      formFreeEmail = document.querySelector('[name="free_email"]'),
      formGenericEmail = document.querySelector('[name="generic_email"]'),
      formMalformedEmail = document.querySelector('[name="malformed_email"]'),
      formWebinarSfdcStatus = document.querySelector('[name="webinar-modal-form-status"]'),
      sfdcAdditionalNotes = document.querySelector('[name="additional_notes"]'),
      sfdcPrimaryProduct = document.querySelector('[name="primary_product"]'),
      sfdcSecondaryProduct = document.querySelector('[name="secondary_product"]');

    submitBtn.setAttribute("disabled", "disabled");
    submitBtn.value = submitBtn.dataset.btndisabled;

    var dataRequest = {
      action: "bstack_instapage_form_ajax",
      security: ajax_initialize_script.ajax_nonce, // nonce
      "form-email": ContactForm.emailField.value.trim(),
      "form-name": ContactForm.fnameField.value.trim(),
      "form-company": ContactForm.lnameField.value.trim(),
      "form-page-url": formPageUrl ? formPageUrl.value : "",
      "form-list-id": formListId ? formListId.value : "",
      "form-tag": formTag ? formTag.value : "",
      "form-post-id": formPostId ? formPostId.value : "",
      "form-id": formId ? formId.value : "",
      "company": formCompany ? formCompany.value : '',
      "title": formTitle ? formTitle.value : '',
      "phone_number": formPhoneNumber ? formPhoneNumber.value : '',
      "mobile_number": formMobileNumber ? formMobileNumber.value : '',
      "company_country": formCompanyCountry ? formCompanyCountry.value : '',
      "company_website": formCompanyWebsite ? formCompanyWebsite.value : '',
      "management_level": formManagementLevel ? formManagementLevel.value : '',
      "company_size": formCompanySize ? formCompanySize.value : '',
      "job_function": formJobFunction ? formJobFunction.value : '',
      "job_department": formJobDepartment ? formJobDepartment.value : '',
      "company_industry": formCompanyIndustry ? formCompanyIndustry.value : '',
      "secondary_email_address": formSecondaryEmailAddress ? formSecondaryEmailAddress.value : '',
      "person_linkedin_url": formLinkedInLead ? formLinkedInLead.value : '',
      "neverbounce_email_status": formEmailValidityCheck ? formEmailValidityCheck.value : '',
      "company_revenue": formEstimatedRevenue ? formEstimatedRevenue.value : '',
      "free_email": formFreeEmail ? formFreeEmail.value : '',
      "generic_email": formGenericEmail ? formGenericEmail.value : '',
      "malformed_email": formMalformedEmail ? formMalformedEmail.value : '',
      "status": formWebinarSfdcStatus ? formWebinarSfdcStatus.value.trim() : '',
      "additional_notes": sfdcAdditionalNotes ? sfdcAdditionalNotes.value.trim() : '',
      "primary_product": sfdcPrimaryProduct ? sfdcPrimaryProduct.value.trim() : '',
      "secondary_product": sfdcSecondaryProduct ? sfdcSecondaryProduct.value.trim() : '',
      "page_url": window.location.href,
      "previous_page_url": (document.referrer !== '') ? document.referrer : 'organic',
      ga_cid: bsLib.GAClientID()
    };

    if (contactformcaptcha) {
      var grecaptchaResponse =
        typeof grecaptcha !== "undefined"
          ? grecaptcha.getResponse(captchaWidgetId)
          : "";

      dataRequest["g-recaptcha-response"] = grecaptchaResponse;

      if (grecaptchaResponse.length === 0) {
        new bsAlert({
          alertType: "error",
          timeout: 5000,
          text: Messages.salesAndSupportPage.noRecaptcha,
        });

        return false;
      }
    }

    // demo request field value
    var modalDemoReqOpt = document.querySelector('.tingle-modal #modal-demo-request-option'),
      modalDemoReqOptHeight = modalDemoReqOpt ? modalDemoReqOpt.offsetHeight : 0;

    if (modalDemoReqOptHeight) {
      dataRequest['demo_requested'] = modalDemoReqMsg ? modalDemoReqMsg : 'Not Selected';
    }

    //ajax request
    bsLib.ajax(
      "POST",
      websiteHost + "/wp-admin/admin-ajax.php",
      dataRequest,
      true,
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }, //request header
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          submitBtn.removeAttribute("disabled");
          submitBtn.value = submitBtn.dataset.btntext;

          var dataResponse = bsLib.JSONParse(data.response);
          if (dataResponse.status === 1) {
            // add class in body for GA4 events
            document.querySelector('body').classList.add('webinar-main-lp-form');

            if (typeof ga !== "undefined") {
              //GA Pageview
              if (formPageView) {
                ga("browserstack.send", "pageview", formPageView.value);
              }

              //GA Goal
              if (formGAGoal) {
                ga(
                  "browserstack.send",
                  "event",
                  bsLib.JSONParse(formGAGoal.value)
                );
              }

              //Recotap GA Goal tracking
              ga(
                "browserstack.send",
                "event",
                "recotap_event",
                "conversion",
                "webinar_registration"
              );
            }

            if (formId.value === "webinars") {
              if (window.lintrk !== undefined) {
                window.lintrk('track', { conversion_id: 9342737 });
              }
            }

            //Set Cookie
            if (userStateForEvent) {
              document.body.classList.add("eventSummit-variation");
              Cookie.create(userStateForEvent.value, "1", 90);
            }

            //linkedin pixel
            if (formLinkedinPixel.value === "1") {
              var node = document.createElement("img");
              node.setAttribute(
                "src",
                "https://px.ads.linkedin.com/collect/?pid=207529&conversionId=3369665&fmt=gif"
              );
              node.classList.add("hide");
              webinarFormBlock.appendChild(node);
            }

            // reset demo requested value to not selected
            if (modalDemoReqOptHeight) {
              modalDemoReqMsg = 'Not Selected';
            }

            // fire demo request field form submission vwo goal
            if (modalDemoReqOptHeight && popUpCSFOptions.vwoShow) {
              window._vis_opt_queue = window._vis_opt_queue || [];
              window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(210);});
            }

            //reset form
            webinarFormBlock.querySelector("form").reset();

            //page redirect
            if (formRedirect.value.trim() !== "") {
              window.location.href = formRedirect.value.trim();
            }

            captchaWidgetId = undefined;

            //modal open
            var modalContainer = document.querySelector(".webinar-popup-modal");
            if (modalContainer) {
              var custModalVideo = new tingle.modal({
                cssClass: ["small-modal"],
                onOpen: function () {
                  webinarModal.destroy();
                },
                onClose: function () {
                  document.querySelector('body').classList.remove('webinar-main-lp-form');
                  custModalVideo.destroy();
                },
              });
              custModalVideo.setContent(modalContainer.innerHTML);
              custModalVideo.open();
            }
          } else {
            new bsAlert({
              alertType: "error",
              timeout: false,
              text: dataResponse.errormsg,
            });
          }
        }
      },
      // Custom Error message for user token.
      function () {}
    );
  }
  return false;
}
